import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { adminApi, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ChangePasswordDialog({ open, forced = false, onClose }) {
  const { refreshAdmin, adminUser } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("New passwords do not match");
    setBusy(true);
    try { await adminApi.changePassword(cur, pw); toast.success("Password updated"); setCur(""); setPw(""); setPw2(""); refreshAdmin(); onClose?.(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !forced) onClose?.(); }}>
      <DialogContent className="max-w-md [&>button]:hidden" data-testid="change-password-dialog" onInteractOutside={(e) => forced && e.preventDefault()} onEscapeKeyDown={(e) => forced && e.preventDefault()}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-[#D46117]" /> {forced ? "Set a new password" : "Change password"}</DialogTitle></DialogHeader>
        {forced && <p className="rounded-xl bg-[#FBEEF4] p-3 text-sm text-[#28282E]" data-testid="change-password-forced-note">Welcome, {adminUser?.name}. You're signed in with a temporary password — please choose your own before continuing.</p>}
        <form onSubmit={submit} className="space-y-3">
          <div><Label className="text-xs">Current (temporary) password</Label><Input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="mt-1" /></div>
          <div><Label className="text-xs">New password (min 8 characters)</Label><Input data-testid="cp-new" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} className="mt-1" /></div>
          <div><Label className="text-xs">Repeat new password</Label><Input data-testid="cp-new2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="mt-1" /></div>
          <div className="flex justify-end gap-2 pt-1">
            {!forced && <Button type="button" variant="outline" onClick={onClose} className="border-slate-200">Cancel</Button>}
            <Button type="submit" data-testid="cp-submit" disabled={busy} className="bg-[#28282E] text-white hover:bg-[#1F1F24]">{busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null} Save new password</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
